module.exports = __webpack_public_path__ + "static/media/5.a192f9c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/5.png
// module id = 2074
// module chunks = 0